/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreateProcedureReceivables/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CreateNewTask from './CreateNewTask/index'
import CreateTask from './CreateTask/index'
import IsSkippable from './IsSkippable/index'
import NewTask from './NewTask/index'
import React from 'react'
import Task from './Task/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CreateProcedureReceivables({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CreateProcedureReceivables"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="CreateProcedureReceivables.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1DwLib': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<IsSkippable
  viewPath={`${viewPath}/IsSkippable`}
/>
<CreateTask
  viewPath={`${viewPath}/CreateTask`}
/>
<CreateNewTask
  viewPath={`${viewPath}/CreateNewTask`}
/>
</div>
<Task
  viewPath={`${viewPath}/Task`}
/>
<NewTask
  viewPath={`${viewPath}/NewTask`}
/>
{children}
</React.Fragment>)
}